import PropTypes from 'prop-types';
import React from "react";
import { useSelector } from "react-redux";
import styled, { css } from 'styled-components';

const Btn = styled.button`
  appearance: none;
  background-color: initial;
  border: none;
  outline: unset;
  box-shadow: none;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  background: center /contain no-repeat;

  -webkit-tap-highlight-color :  rgba(255, 255, 255, 0); 
  -webkit-touch-callout: none;
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;

  ${(props) => (props.type === 'bookMenu' && css`
    position: relative;
    width: 391px;
    height: 506px;
    filter: drop-shadow(10px 10px rgba(0,0,0,0.15));
    transition: filter 0.6s cubic-bezier(0.16, 1, 0.3, 1);

    &:hover {
      filter: drop-shadow(0 0 rgba(0,0,0,0.15));

      img {
        top:10px;
        left:10px;
      }
    }
  `)}

  ${(props) => (props.type === 'menu' && css`
    background-size: contain;
    position: absolute;

    &:hover::after {
      content: "";
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      height: 157px;
      background-size: contain;
    }

    ${(props) => props.animal === 'rabbit' && css`
      width: 302px;
      height: 497px;
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/main/rabbit.png);
      top: 505px;
      left: 274px;

      &:hover {
        background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/main/rabbit_h.png);

        &::after {
          background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/main/rabbit_tooltip.png);
          width: 434px;
        }
      }
    `}

    ${(props) => props.animal === 'fox' && css`
      width: 362px;
      height: 465px;
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/main/fox.png);
      top: 537px;
      left: 771px;

      &:hover {
        background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/main/fox_h.png);

        &::after {
          background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/main/fox_tooltip.png);
          width: 433px;
        }
      }
    `}

    ${(props) => props.animal === 'sheep' && css`
      width: 385px;
      height: 447px;
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/main/sheep.png);
      top: 555px;
      left: 1324px;

      &:hover {
        background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/main/sheep_h.png);

        &::after {
          background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/main/sheep_tooltip.png);
          width: 571px;
          height: 156px;
        }
      }
    `}
  `)}

  ${(props) => props.type === 'home' && css`
    left: 1802px;
    transition: transform 0.1s;
    width: 65px;
    top: 32px;
    position: absolute;
    z-index: 2;

    &:active {
      transform: scale(90%);
      transform-origin: center;
    }
  `}

  ${(props) => props.type === 'back' && css`
    left: 1802px;
    transition: transform 0.1s;
    width: 65px;
    top: 109px;
    position: absolute;
    z-index: 2;

    &:active {
      transform: scale(90%);
      transform-origin: center;
    }
  `}

  ${(props) => props.type === 'bookMark' && css`
    background: center /contain no-repeat;
    position: absolute;
    z-index: 2;
    top: 20px;
    left: 1677px;
    width: 52px;
    height: 66px;
    background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/ebook/e-book_bookmark_off.png);
    filter: drop-shadow(0 2px 1px rgba(0, 0, 0, 0.30));

    &.act {
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/ebook/e-book_bookmark_on.png);
    }
  `}
  
  ${(props) => (props.type === 'book' && css`
    position: absolute;
    bottom: ${props.bottom};
    left: ${props.left};
    z-index: 2;
    width: 45px;
    height: 49px;

    ${(props) => props.value === 'answer' && 'background: url(https://content.chungchy.com/PhonicsHero/web_resource/images/ebook/btn_answer.png) center / contain no-repeat;'}
    ${(props) => props.value === 'track' && 'background: url(https://content.chungchy.com/PhonicsHero/web_resource/images/ebook/btn_track.png) center / contain no-repeat;'}
    ${(props) => props.value === 'card' && 'background: url(https://content.chungchy.com/PhonicsHero/web_resource/images/ebook/btn_card.png) center / contain no-repeat;'}
    ${(props) => props.value === 'chant' && 'background: url(https://content.chungchy.com/PhonicsHero/web_resource/images/ebook/btn_chant.png) center / contain no-repeat;'}
    ${(props) => props.value === 'video' && 'background: url(https://content.chungchy.com/PhonicsHero/web_resource/images/ebook/btn_video.png) center / contain no-repeat;'}

    &:active {
      transform: scale(85%);
    }
  `)}

  ${(props) => props.type === 'go' && css`
    width: 60px;
    height: 100%;
    border-radius: 0 5px 5px 0;
    background-color: #fbc442;
    font-size: 18px;
    font-weight: 600;
  `}

  ${(props) => props.type === 'ebook' && css`
    position: absolute;
    top: 0;
    left: 100%;
    width: 30px;
    height: 30px;
    background: #fbc442 url(https://content.chungchy.com/PhonicsHero/web_resource/images/ebook/pagenation_pre.png) center /7px 13px no-repeat;

    &.act {
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/ebook/pagenation_next.png);
    }
  `}

  ${(props) => props.type === 'page' && css`
    width: 11px;
    height: 20px;
    margin: 0 11px;
    z-index: 2;
  `}

  ${(props) => (props.type === 'tool' && css`
    width: 50px;
    height: 50px;
    margin-bottom: 10px;
    background: center / contain no-repeat;

    ${(props) => (props.name === 'select' && css`
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/toolKit/toolbox_click.png);

      &:hover, &.act {
        background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/toolKit/toolbox_click_hover.png);
      }
    `)}

    ${(props) => (props.name === 'memo' && css`
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/toolKit/toolbox_memo.png);

      &:hover, &.act {
        background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/toolKit/toolbox_memo_hover.png);
      }
    `)}

    ${(props) => (props.name === 'pen' && css`
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/toolKit/toolbox_pen.png);

      &:hover, &.act {
        background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/toolKit/toolbox_pen_hover.png);
      }
    `)}

    ${(props) => (props.name === 'color' && css`
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/toolKit/toolbox_color_pen.png);

      &:hover, &.act {
        background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/toolKit/toolbox_color_pen_hover.png);
      }
    `)}

    ${(props) => (props.name === 'eraser' && css`
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/toolKit/toolbox_eraser.png);

      &:hover, &.act {
        background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/toolKit/toolbox_eraser_hover.png);
      }
    `)}

    ${(props) => (props.name === 'reset' && css`
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/toolKit/toolbox_all_eraser.png);

      &:hover, &.act {
        background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/toolKit/toolbox_all_eraser_hover.png);
      }
    `)}

    ${(props) => (props.name === 'telescope' && css`
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/toolKit/toolbox_telescope.png);

      &:hover, &.act {
        background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/toolKit/toolbox_telescope_hover.png);
      }
    `)}
  `)}

  ${(props) => props.type === 'close' && css`
    position: absolute;
    transition: left 0.3s;
    width: 60px;
    height: 60px;
    top: 159px;
    left: 1713px;
    
    ${(props) => props.value === 'video' && css`
      top: 279px;
      left: 1422px;
    `}
    
    ${(props) => props.value === 'card' && css`
      top: 158px;
      left: 1615px;
    `}
    
    ${(props) => !props.menu && (props.value === 'video' ? ('left : 1341px;') : (props.value === 'card' ? 'left: 1534px;' : 'left : 1632px;'))}

    ${props.value === 'game' && css`
      ${props.book === 0 && css`
        top: 110px;
        ${!props.menu ? css` left: 1607px;` : css`left: 1688px;`}
      `} 

      ${(props.book === 1 || props.book === 2) && css`
        top: 111px;
        ${!props.menu ? css`left: 1608px;` : css`left: 1689px;`}
      `}
    `}
  `}


  ${(props) => props.type === 'audio' && css`
    background: center /contain no-repeat;
    width: 120px;
    height: 109px;

    ${props.page && css`
      width: 171px;
      height: 155px;
    `}

    ${(props) => props.name === 'prev' && 'background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_btn_pre.png);'}
    ${(props) => props.name === 'next' && 'background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_btn_next.png);'}
    ${(props) => props.name === 'play' && 'margin: 0 30px; background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_btn_play.png);'}
    
    ${(props) => props.name === 'play' && '&.act {background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_btn_pause.png);'}
  `}

  ${(props) => props.type === 'repeat' && css`
    width: 35px;
    height: 44px;
    background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_btn_repeat_off.png);

    ${props.page && css`
      width: 50px;
      height: 63px;
    `}
    
    &.act {
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_btn_repeat_on.png);
    }
  `}

  ${(props) => props.type === 'play' && css`
    background: center /contain no-repeat;
    width: 31px;
    height: 36px;
    background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/videoPlayer/chant_btn_play.png);

    &.act {
      width: 39px;
      height: 39px;
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/videoPlayer/chant_btn_pause.png);
    }
  `}

  ${(props) => props.type === 'fullscreen' && css`
    background: center /contain no-repeat;
    width: 35px;
    height: 35px;
    background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/videoPlayer/icon.png);
  `}

  ${(props) => props.type === 'slide' && css`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 44px;
    height: 74px;

    ${(props) => props.value === 'prev' && css`
      left : 0;
      z-index: 1;
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/flashCard/fc_prev_on.png);
    `}

    ${(props) => props.value === 'next' && css`
      right: 0;
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/flashCard/fc_next_on.png);
    `}
  `}

  ${(props) => props.type === 'memoClose' && css`
    position: absolute;
    top: 15px;
    right: 28px;
    width: 15px;
    height: 15px;
  `}

  ${(props) => props.type === 'resource' && css`
    width: 211px;
    height: 240px;
    border-radius: 35px;
    box-sizing: content-box;
    padding: 15px 0;
  `}
`;

export const Button = (props) => {
  const state = useSelector((state) => state);

  return (
    <Btn 
      type={props.type} 
      value={props.value}
      animal={props.animal} 
      className={props.className} 
      onClick={props.onClick} 
      name={props.name} 
      bottom={props.bottom} 
      left={props.left}
      menu={state.menu.act}
      prev={state.card.prev}
      next={state.card.next}
      disabled={props.disabled}
      book={state.book.current_book}
      onMouseOver={props.onMouseOver}
      page={props.page}
    >
      {props.children}
    </Btn>
  );
};

Button.propTypes = {
  type : PropTypes.string,
  animal : PropTypes.string,
  className : PropTypes.string,
  name : PropTypes.string,
  bottom : PropTypes.string,
  left : PropTypes.string,
  ref : PropTypes.any,
  act : PropTypes.bool
};

Button.defaultProps = {
  type : 'bookMenu'
};